import { render } from "./StatChart.vue?vue&type=template&id=5b107a2f&scoped=true"
import script from "./StatChart.vue?vue&type=script&lang=js"
export * from "./StatChart.vue?vue&type=script&lang=js"

import "./StatChart.vue?vue&type=style&index=0&id=5b107a2f&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b107a2f"]])

export default __exports__